export default __webpack_public_path__ + "static/media/caja-de-servicio.f79f4f9c.svg";